// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2Utkb){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_11n1h .dualColumn_6GmkC{display:flex;align-content:space-between}.nsAddressForm_11n1h .dualColumn_6GmkC .firstCol_2tCpK{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2Utkb",
	"nsAddressForm": "nsAddressForm_11n1h",
	"dualColumn": "dualColumn_6GmkC",
	"firstCol": "firstCol_2tCpK"
};
module.exports = exports;
